import Vue from 'vue'
import Router from 'vue-router'
// Site
import Home from './pages/site/Home.vue';
// VecDyn
import CurateVecDyn from "./pages/vecdyn/CurateVecDyn.vue"
import ExploreVecdyn from "./pages/vecdyn/ExploreVecDyn.vue" // this is an obsolete version kept for historical reasons
import SubmitVecdyn from "./pages/vecdyn/SubmitVecdynData.vue"
import SubmitVecdynSubassay from "./pages/vecdyn/SubmitVecdynSubassay.vue"
import VecdynDatasets from './pages/vecdyn/VecdynDatasets.vue'
import VecdynDetail from './pages/vecdyn/VecdynDetail.vue'
import VecDynFileUploadDetail from "./pages/vecdyn/VecDynFileUploadDetail.vue"
import VecdynColumnDefs from './pages/vecdyn/VecdynColumnDefs.vue'
import VecDynPublicationInfoEdit from './pages/vecdyn/VecDynPublicationInfoEdit.vue'
import AssayTypes from './pages/vecdyn/AssayTypes.vue'
import AssayProtocols from './pages/vecdyn/AssayProtocols.vue'
// VecTraits
import CurateVectraits from "./pages/vectraits/CurateVectraits.vue"
import SubmitVectraits from "./pages/vectraits/SubmitVectraitsData.vue"
import VectraitsColumnDefs from './pages/vectraits/VectraitsColumnDefs.vue'
import VectraitsExplorer from './pages/vectraits/VectraitsExplorer.vue'
import VectraitsDataset from './pages/vectraits/VectraitsDataset.vue'
import VectraitsFileUploadDetail from "./pages/vectraits/VectraitsFileUploadDetail.vue"
import VectraitsCitationEdit from './pages/vectraits/VectraitsCitationEdit.vue'
// VCC
import Login from './pages/vcc/Login.vue'
import ForgotPassword from './pages/vcc/ForgotPassword.vue'
import Register from './pages/vcc/Register.vue'
import ResetPassword from '@/pages/vcc/ResetPassword.vue';
import PageNotFound from './pages/vcc/PageNotFound.vue';
import UserNotAuthorized from './pages/vcc/UserNotAuthorized.vue';
// Dashboard
import DashboardRoot from './pages/dashboard/DashboardRoot.vue';
import Dashboard from './pages/dashboard/Dashboard.vue';
import UserProfile from './pages/user/UserProfile.vue';
import ChangePassword from './pages/user/ChangePassword.vue';
// Dashboard Children
import Charts from '@/components/dashboard/children/Charts.vue'
import Components from '@/components/dashboard/children/Components.vue'
import Map from '@/components/dashboard/children/Map.vue'
// Admin
import EditUser from './pages/user/admin/EditUser.vue';
import Users from './pages/user/admin/Users.vue';
import AdminLogs from './pages/user/admin/AdminLogs.vue';
// Sample
import Sample from '@/pages/sample/Sample.vue'

import store from '@/store/store';
// import user from './store/modules/user';

Vue.use(Router)

store.dispatch('initApp');

store.dispatch('user/initUser');
store.dispatch('user/initMyGroups');

// store.dispatch('user/getUser').then(res => {
//   store.dispatch('user/setUser', res.data);
// });

// store.dispatch('user/getMyGroups').then(res => {
//   store.dispatch('user/setMyGroups', res.data);
// });

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    // SITE ROUTES ------
    {
      path: '/',
      name: 'home',
      component: Home
    },
    // VECDYN ROUTES ------
    { // This route should be removed when it's no longer needed as an example.
      path: '/explore-vecdyn/',
      name: 'explore-vecdyn',
      component: ExploreVecdyn
    },
    {
      path: '/vecdyn-columndefs/',
      name: 'vecdyn-columndefs',
      component: VecdynColumnDefs,
    },
    {
      path: '/vecdyn-datasets/',
      name: 'vecdyn-datasets',
      component: VecdynDatasets
    },
    // {
    //   path: '/vecdyn-detail/:id',
    //   name: 'vecdyn-detail',
    //   component: VecdynDetail,
    //   props: true,
    // },
    {
      path: '/vecdyn-detail/:id/:embargo_key?',
      name: 'vecdyn-detail',
      component: VecdynDetail,
      props: true,
    },
    {
      path: '/submit-vecdyn/',
      name: 'submit-vecdyn',
      component: SubmitVecdyn,
      meta: {
        requiresAuth: true
      },
      beforeEnter(to, from, next) {
        if (store.getters['user/inMyGroups'](['admin', 'uploader', 'collaborator'])) {
          next()
        } else {
          next({
            name: 'login',
            query: {
              next: to.fullPath
              // next: '/'
            }
          })
        }
      }
    },
    {
      path: '/vecdyn-subassay-upload/:id',
      name: 'vecdyn-subassay-upload',
      component: SubmitVecdynSubassay,
      props: true,
      meta: {
        requiresAuth: true
      },
      beforeEnter(to, from, next) {
        if (store.getters['user/inMyGroups'](['admin', 'uploader', 'collaborator'])) {
          next()
        } else {
          next({
            name: 'login',
            query: {
              next: to.fullPath
            }
          })
        }
      }
    },
    {
      path: '/assay-types/',
      name: 'assay-types',
      component: AssayTypes,
      meta: { requiresAuth: true },
      beforeEnter(to, from, next) {
        if (store.getters['user/inMyGroups'](['admin', 'uploader', 'collaborator'])) {
          next()
        } else {
          next({ name: 'login', query: { next: to.fullPath } })
        }
      }
    },
    {
      path: '/assay-protocols/',
      name: 'assay-protocols',
      component: AssayProtocols,
      meta: { requiresAuth: true },
      beforeEnter(to, from, next) {
        if (store.getters['user/inMyGroups'](['admin', 'uploader', 'collaborator'])) {
          next()
        } else {
          next({ name: 'login', query: { next: to.fullPath } })
        }
      }
    },
    {
      path: '/curate-vecdyn/',
      name: 'curate-vecdyn',
      component: CurateVecDyn,
      meta: {
        requiresAuth: true
      },
      beforeEnter(to, from, next) {
        if (store.getters['user/inMyGroups'](['admin', 'collaborator'])) {
          next()
        } else {
          next({
            name: 'login',
            query: {
              next: decodeURIComponent(to.fullPath)
              // next: '/'
            }
          })
        }
      }
    },
    {
      path: '/vecdyn-publicationinfo-edit/:id',
      name: 'vecdyn-publicationinfo-edit',
      component: VecDynPublicationInfoEdit,
      props: true,
      meta: {
        requiresAuth: true
      },
      beforeEnter(to, from, next) {
        if (store.getters['user/inMyGroups'](['admin', 'collaborator'])) {
          next()
        } else {
          next({
            name: 'login',
            query: {
              next: to.fullPath
            }
          })
        }
      }
    },
    {
      path: '/vd-fileupload-detail/:id',
      name: 'vd-fileupload-detail',
      component: VecDynFileUploadDetail,
      props: true,
      beforeEnter(to, from, next) {
        if (store.getters['user/inMyGroups'](['admin', 'collaborator'])) {
          next()
        } else {
          next({
            name: 'dashboard',
            query: {
              next: to.fullPath
              // next: '/'
            }
          })
        }
      }
    },
    // VECTRAITS ROUTES ------
    {
      path: '/vectraits-columndefs/',
      name: 'vectraits-columndefs',
      component: VectraitsColumnDefs,
    },
    {
      path: '/vectraits-explorer/',
      name: 'vectraits-explorer',
      component: VectraitsExplorer,
    },
    // {
    //   path: '/vectraits-dataset/:id',
    //   name: 'vectraits-dataset',
    //   component: VectraitsDataset,
    //   props: true,
    // },
    {
      path: '/vectraits-dataset/:id/:embargo_key?',
      name: 'vectraits-dataset',
      component: VectraitsDataset,
      props: true,
    },
    {
      path: '/submit-vectraits/',
      name: 'submit-vectraits',
      component: SubmitVectraits,
      meta: {
        requiresAuth: true
      },
      beforeEnter(to, from, next) {
        if (store.getters['user/inMyGroups'](['admin', 'uploader', 'collaborator'])) {
          next()
        } else {
          next({
            name: 'login',
            query: {
              next: to.fullPath
              // next: '/'
            }
          })
        }
      }
    },
    {
      path: '/curate-vectraits/',
      name: 'curate-vectraits',
      component: CurateVectraits,
      meta: {
        requiresAuth: true
      },
      beforeEnter(to, from, next) {
        if (store.getters['user/inMyGroups'](['admin','collaborator'])) {
          next()
        } else {
          next({
            name: 'login',
            query: {
              next: to.fullPath
              // next: '/'
            }
          })
        }
      }
    },
    {
      path: '/vectraits-citation-edit/:id',
      name: 'vectraits-citation-edit',
      component: VectraitsCitationEdit,
      props: true,
      meta: {
        requiresAuth: true
      },
      beforeEnter(to, from, next) {
        if (store.getters['user/inMyGroups'](['admin', 'collaborator'])) {
          next()
        } else {
          next({
            name: 'login',
            query: {
              next: to.fullPath
            }
          })
        }
      }
    },
    {
      path: '/vt-fileupload-detail/:id',
      name: 'vt-fileupload-detail',
      component: VectraitsFileUploadDetail,
      props: true,
      beforeEnter(to, from, next) {
        if (store.getters['user/inMyGroups'](['admin', 'collaborator'])) {
          // console.log("AUTHORIZED");
          next()
        } else {
          // console.log("NOT AUTHORIZED");
          next({
            name: 'login',
            query: {
              next: to.fullPath
            }
          })
        }
      }
    },
    {
      path: '/admin-logs/',
      name: 'admin-logs',
      component: AdminLogs,
      meta: {
        requiresAuth: true
      },
      beforeEnter(to, from, next) {
        if (store.getters['user/inMyGroups'](['admin'])) {
          next()
        } else {
          next({
            name: 'login',
            query: {
              next: to.fullPath
            }
          })
        }
      }
    },
    // VCC ROUTES ------
    {
      path: '/login/',
      name: 'login',
      component: Login
    },
    {
      path: '/register/',
      name: 'register',
      component: Register
    },
    {
      path: '/forgot-password/',
      name: 'forgot-password',
      component: ForgotPassword
    },
    {
      path: '/reset-password/',
      name: 'reset-password',
      component: ResetPassword
    },
    {
      path: '/unauthorized/',
      name: 'unauthorized',
      component: UserNotAuthorized
    },
    {
      path: '/dashboard/',
      component: DashboardRoot,
      meta: {
        requiresAuth: true
      },
      children: [{
          path: '',
          name: 'dashboard',
          component: Dashboard
        },
        {
          path: 'user',
          name: 'user',
          component: UserProfile
        },
        {
          path: 'components',
          name: 'components',
          component: Components
        },
        {
          path: 'map',
          name: 'map',
          component: Map
        },
        {
          path: 'charts',
          name: 'charts',
          component: Charts
        },
        {
          path: 'edit-user/:userId',
          name: 'edit-user',
          component: EditUser
        },
        {
          path: 'users',
          name: 'users',
          component: Users
        },
        {
          path: 'change-password',
          name: 'change-password',
          component: ChangePassword
        }
      ]
    },
    // SAMPLE ROUTES ------
    {
      path: '/sample/',
      name: 'sample',
      component: Sample
    },
    // EVERYTHING ELSE
    {
      path: '*',
      name: 'not-found',
      component: PageNotFound
    }
  ]
});
// this is a very superfluous comment.
// before entering each route:
router.beforeEach((to, from, next) => {
  // if the route has a meta containing "requiresAuth: true":
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // get the state copy of Authorization (defined in @/store/store.js)
    if (store.getters.isAuthenticated) {
      /*  TODO: wrap this block with another "if (to.matched.some(record => record.meta.requiresROLES)" */
      // if authorized, proceed to route
      next();
    } 
    // if not authorized and the user has already hit the login page and cancelled the login, display
    // the 401 unauthorized page.
    else if (from.matched.some(record => record.name === 'login')) {
      next({
        name: 'unauthorized',
        query: {
          next: to.fullPath
        }
      })
    }
    // if the user has not already hit the login page, direct them to said page.
    else {
      next({
        name: 'login',
        query: {
          next: decodeURIComponent(to.fullPath)
          // next: to.window.location.pathname
        }
      });
    }
  } else {
    next();
  }
});

export default router;